/* eslint-disable react/jsx-key */
import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { Route } from '@americanexpress/one-app-router';
import CommonError from './components/CommonError';
import updateLocaleFromRoute from './updateLocaleFromRoute';
/* istanbul ignore next */
const RootModule = (store) => [
  <ModuleRoute>
    <ModuleRoute
      path=":locale/travel/travelers-cheques/locator"
      title="Travelers Cheques Encashment Locator"
      moduleName="axp-maps-travelers-cheques-encashment-locations"
      onEnter={updateLocaleFromRoute(store)}
    />
    <ModuleRoute
      path=":locale/travel/travelers-cheques/customerservice"
      title="Customer Service"
      moduleName="axp-travelers-cheques-contact-us"
      onEnter={updateLocaleFromRoute(store)}
    />
    <ModuleRoute
      path="/"
      component={() => {
        global.window && (global.window.location.href = 'https://www.americanexpress.com/us/travel/travelers-cheques/?inav=menu_travel_cheques');
      }}
    />
  </ModuleRoute>,
  <Route
    key="/"
    path=":locale/travel/travelers-cheques/locator/error"
    onEnter={updateLocaleFromRoute(store)}
    component={CommonError}
  />,
];

export default RootModule;
